export default {
    cn: {
        reuse: {
            showTotal: '显示条目总数:',
            total: '条目总数:',
            current: '当前:',
            noData: '没有数据',
            downloadExcelForms: '下载 Excel',
            selectTimeText: '请选择日期',
            pleaseInputNumber: '请输入数字',
            moreSelect: '显示更多筛选',
            searchText: '搜 索',
            refresh: '刷 新',
            upload: '上传 Html',
            typeMaps: { "0": "今日", "1": "今周", "2": "今月", "3": "自定义" },
            serverError: '服务器响应失败',
            invalidParam: '无效的参数',
            startTime: '开始时间',
            endTime: '结束时间',
            loginText: '账号：',
            groupText: '组别：',
            ibNumText: '代理账号：',
            officeText: '办事处号码：',
            regionText: '地区编号：',
            nameFilterText: '名字过滤：',
            loginFilterText: '账号过滤：',
            cmdMapping: { 0: '买入', 1: '卖出' },
            selectAll: { key: "selectAll", label: "全选" },
            rememberMyChoice: { key: "rememberMyChoice", label: "记住我的选择" },
            showMoreColumns: "显示更多列",
        }
    },
    hk: {
        reuse: {
            showTotal: '顯示條目總數:',
            total: '條目總數:',
            current: '當前:',
            noData: '沒有數據',
            downloadExcelForms: '下載 Excel',
            selectTimeText: '請選擇日期',
            pleaseInputNumber: '請輸入數字',
            moreSelect: '顯示更多篩選',
            searchText: '搜 索',
            refresh: '刷 新',
            upload: '上傳 Html',
            typeMaps: { "0": "今日", "1": "今周", "2": "今月", "3": "自定義" },
            serverError: '服務器響應失敗',
            invalidParam: '無效的參數',
            startTime: '開始時間',
            endTime: '結束時間',
            loginText: '賬號：',
            groupText: '組別：',
            ibNumText: '代理賬號：',
            officeText: '辦事處號碼：',
            regionText: '地區編號：',
            nameFilterText: '名字過濾：',
            loginFilterText: '賬號過濾：',
            cmdMapping: { 0: '買入', 1: '賣出' },
            selectAll: { key: "selectAll", label: "全選" },
            rememberMyChoice: { key: "rememberMyChoice", label: "記住我的選擇" },
            showMoreColumns: "顯示更多列",
        }
    },
    en: {
        reuse: {
            showTotal: 'Display Record Count:',
            total: 'Record Total Count:',
            current: 'Current:',
            noData: 'No data',
            downloadExcelForms: 'Download Excel',
            selectTimeText: 'Please Select Date',
            pleaseInputNumber: 'Please Input Number',
            moreSelect: 'Show More',
            searchText: 'Search',
            refresh: 'Refresh',
            upload: 'Upload Html',
            typeMaps: { "0": "Today", "1": "This Week", "2": "This Month", "3": "Custom" },
            serverError: 'Server Response Failed',
            invalidParam: 'Invalid Parameter',
            startTime: 'Start Time',
            endTime: 'End Time',
            loginText: 'Login：',
            groupText: 'Group：',
            ibNumText: 'IB Account：',
            officeText: 'Office ID：',
            regionText: 'Region ID：',
            nameFilterText: 'Name Filter：',
            loginFilterText: 'Login Filter：',
            cmdMapping: { 0: 'Buy', 1: 'Sell' },
            selectAll: { key: "selectAll", label: "Select All" },
            rememberMyChoice: { key: "rememberMyChoice", label: "Remember My Choice" },
            showMoreColumns: "Visible Columns",
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/reuse.js